import type { ReactNode } from 'react';
import { Card } from '../ui';
import './layout.css';

export interface CenteredCardLayoutProps {
  children: ReactNode;
}

/** Centered single-card layout for /login, /onboarding, /auth/complete, /error. */
export function CenteredCardLayout({ children }: CenteredCardLayoutProps) {
  return (
    <div className="centered">
      <div className="centered__inner">
        <Card>{children}</Card>
      </div>
    </div>
  );
}

export function Brand() {
  return (
    <div className="brand">
      <img className="brand__logo" src="/favicon.svg" alt="" aria-hidden="true" />
      <span>Account Portal</span>
    </div>
  );
}
